import React from 'react';
import DragIndicatorIcon from '@mui/icons-material/DragIndicator';

const OrderTransformation = ({ orderData, setOrderData, setTransformation }) => {
  const handleDragStart = (e, index) => {
    e.dataTransfer.setData('text/plain', index); // Corrected method
  };

  const handleDragOver = (e) => {
    e.preventDefault();
  };

  const handleDrop = (e, targetIndex) => {
    const sourceIndex = e.dataTransfer.getData('text/plain'); // Retrieve the data
    const newData = [...orderData];
    const [draggedItem] = newData.splice(sourceIndex, 1);
    newData.splice(targetIndex, 0, draggedItem);
    setOrderData(newData);
    setTransformation((prev) => ({
      ...prev,
      params: { ...prev.params, order: newData },
    }));
  };

  return (
    <div style={{ position: 'relative', marginTop: '12px' }}>
      <p
        style={{
          position: 'absolute',
          top: '-10px',
          left: '10px',
          fontSize: 'small',
          backgroundColor: 'white',
          padding: '0 8px',
          color: 'gray',
        }}
      >
        Order
      </p>

      <div
        style={{
          border: '1px solid lightgray',
          padding: '8px 2px 0 2px',
          borderRadius: '4px',
        }}
      >
        {orderData.map((item, index) => (
          <div
            key={index}
            draggable
            onDragStart={(e) => handleDragStart(e, index)}
            onDragOver={handleDragOver}
            onDrop={(e) => handleDrop(e, index)}
            style={{
              padding: '2px 0',
              marginBottom: '5px',
              display: 'flex',
              alignItems: 'center',
              cursor: 'grab',
            }}
          >
            <DragIndicatorIcon style={{ margin: '0 10px 0 5px', color: 'gray' }} /> {item}
          </div>
        ))}
      </div>
    </div>
  );
};

export default OrderTransformation;
